import { render } from "./SelecaoSubgrupo.vue?vue&type=template&id=ec47d338&scoped=true"
import script from "./SelecaoSubgrupo.vue?vue&type=script&lang=js"
export * from "./SelecaoSubgrupo.vue?vue&type=script&lang=js"

import "./SelecaoSubgrupo.vue?vue&type=style&index=0&id=ec47d338&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec47d338"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection});
